  import React from 'react';
  import Calendar from './Calendar/Calendar'

  function App() {
    return (
      <div className="App">
        <Calendar />
      </div>
    );
  }

  export default App;
